export default __webpack_public_path__ + "static/media/img2.ca664cc1.jpg";